<!--私有工作流定义
定义的是节点，每一个节点的负责人、操作项操作步骤，创建的时候作为模板，选择工作流的时候加载，然后可以修改编辑
-->
<template>
  <div style="background: #F7F7F7;">
    <div class="card-box" v-show="nowFlow == undefined">
      <div v-for="flow in flowList" class="card-nomal">
        <div class="card-title" :style="$store.resourcesStore.getters.getBackgroudImageStyle('card_title_bg.png')">
          {{ flow.name }}
        </div>
        <p class="card-info">创建日期 : {{ flow.createTime }}</p>
        <div class="card-button-box">
          <button class="specialButton" @click="deleteFlow(flow.flowId)">删除</button>
          <button class="nomalButton" @click="edit(flow)">编辑</button>
        </div>
      </div>
      <div class="card-add" @click="addFlow">
        <img class="img-add" :src="$store.resourcesStore.getters.getResourcesByName('/wedoButton/add.png')" />
      </div>
    </div>
    <div v-show="nowFlow != undefined" style="padding: 10px;">
      <button class="nomalButton" @click="backToList">退出到上一级</button>
      <button class="nomalButton" @click="save" v-show="nowFlow != undefined && nowFlow.type == 'adding'">
        保存私有工作流
      </button>
      <button class="nomalButton" @click="save" v-show="nowFlow != undefined && nowFlow.type != 'adding'">
        保存私有工作流
      </button>
      <createNode ref="createNodeBean" :nowFlow="nowTargetFlow"></createNode>
    </div>
  </div>
</template>

<script>
  import listView from '@/components/module/selection/base/listView.vue';
  import scheduleAxis from '@/components/module/axis/scheduleAxis.vue';
  import treeSingleSelection from '@/components/module/selection/base/treeSingleSelection.vue';
  import createNode from '@/page/order/createOrder/createNode.vue';
  export default {
    components: {
      listView,
      scheduleAxis,
      treeSingleSelection,
      createNode
    },
    props: {},
    data () {
      return {
        flowList: [{
          name: '1',
          createTime: '2024/05/31 17:23:10'
        },
        {
          name: '2',
          createTime: '2024/06/31 12:13:06'
        },
        {
          name: '3',
          createTime: '2024/07/31 11:43:30'
        }],
        nowFlow: undefined,
        flag: true
      };
    },

    mounted () {
      debugPage=this;
    },
    destroyed () {},
    computed: {

      nowTargetFlow () {
        if(this.nowFlow==undefined) {
          return {};
        }
        if(this.nowFlow.type=='adding') {
          return this.nowFlow;
        }
        if(this.nowFlow.flowId==undefined) {
          return {};
        }
        return this.$store.workFlowStore.getters.getFlowTreeByFlowId(this.nowFlow.flowId);
      },
      getDate () {
        return item => {
          return new Date(item).formatByTime();
        };
      }
    },
    watch: {},
    beforeDestroy () {

      // this.save(0)
      if(this.nowFlow) {
        this.flag=false
        this.save()
      }
    },
    methods: {
      edit (flow) {
        this.flag=true
        this.nowFlow=flow;
        this.$refs.createNodeBean.getArchive=true;
      },
      addFlow () {
        //点击了新增工作流
        this.$dialogMethod.openNomalInputDialog(
          '创建工作流',
          [
            {
              name: '工作流名称',
              pkid: 'name',

            },
            {
              workTime: new Date().getTime(),
            },{
              workTime: new Date().getTime(),
            }
          ],
          respon => {
            this.nowFlow={
              name: respon.name,
              next: [],
              type: 'adding'
            };
          }
        );
      },
      save () {
        //提交到服务器
        var list=this.$refs.createNodeBean.getData();
        if(list.length==0) {
          this.$dialogMethod.showMessage('至少需要有一个节点!');
          return;
        }
        var nodes=this.$refs.createNodeBean.getData();
        for(var i=0,len=nodes.length;i<len;i++) {
          if(isempty(nodes[i].nodeUsers)) {
            this.$dialogMethod.showMessage('每个节点都必须有负责人!');
            return;
          }
          if(isempty(nodes[i].archivesIds)&&nodes[i].nodeType==2) {
            this.$dialogMethod.showMessage('节点类型为“巡检”时必须选择台账设备!');
            return;
          }
          for(var i1=0,len1=nodes[i].next.length;i1<len1;i1++) {
            var item=nodes[i].next[i1]
            if(isempty(item.next)&&nodes[i].nodeType==0) {
              this.$dialogMethod.showMessage("操作项至少需要有一个操作步骤!")
              return
            }
          }
        }
        if(this.flag) {
          this.$dialogMethod.showLoading('正在保存');
        }
        if(this.nowFlow.type=='adding') {
          this.$api.flowApi.addFlow(this.nowFlow.name,1,JSON.stringify(list),respon => {
            this.$store.workFlowStore.commit('getFlowList');
            if(this.flag) {
              this.$dialogMethod.showMessage('保存成功!');
            }
            this.$dialogMethod.closeLoading();
            this.nowFlow=undefined;
          });
        } else {
          this.$api.flowApi.updateFlow(this.nowFlow.flowId,this.nowFlow.name,1,JSON.stringify(list),respon => {
            this.$store.workFlowStore.commit('getFlowList');
            if(this.flag) {
              this.$dialogMethod.showMessage('保存成功!');
            }
            this.$dialogMethod.closeLoading();
            this.nowFlow=undefined;
          });
        }
      },
      deleteFlow (flowId) {
        //删除工作流
        this.$confirm('此操作将永久删除该信息, 是否继续?','提示',{
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            this.$api.flowApi.deleteFlow(
              flowId,
              respon => {
                if(respon=='删除成功') {
                  this.$message({
                    message: respon,
                    type: 'success'
                  });
                  this.$store.workFlowStore.commit('getFlowList');
                }
              },
              err => {
                this.$message({
                  message: err,
                  type: 'error'
                });
              }
            );
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });
      },
      backToList () {
        this.flag=false
        this.save()
        if(this.nowFlow.type=='adding') {
          //返回到工作流列表
          this.$dialogMethod.openAgreeDialog('退出编辑','所有的未保存操作将会丢失，是否继续？',respon => {
            this.nowFlow=undefined;
          });
        } else {
          this.nowFlow=undefined;
        }
      }
    }
  };
</script>

<style scoped>
  @import url('../../../components/css/card.css');

  .upload {
    background: red;
    border-radius: 10%;
    padding: 0.1rem;
    color: white;
    display: inline-block;
    cursor: pointer;
  }
</style>